export const productAgeEnum = {
  1: '0-6',
  2: '6-12',
  3: '12-18',
  4: '18-24',
  5: '>24',
} as const;
